const BaseURL = "https://stagflexapi.appiness.co.in/api/admin";
const SocketURL = "ws://stagflexapi.appiness.co.in/ws";
const CommonUrl = "https://stagflexapi.appiness.co.in/api/common";

export const API = {

  LOGIN: `${BaseURL}/login/`,
  CHANGE_PASSWORD: `${BaseURL}/change-password/`,
  FORGOT_PASSWORD: `${BaseURL}/forgot-password/`,
  MEDIA_UPLOAD: `${BaseURL}/media-upload/`,
  VIEW_PROFILE: `${BaseURL}/view-profile/`,
  EDIT_PROFILE: `${BaseURL}/edit-profile/`,
  GET_NOTIFICATION: `${BaseURL}/notification`,
  NOTIFICATION_COUNT: `${SocketURL}/admin-notification`,
  GET_RECRUITMENT: `${BaseURL}/recruitment`,

  GET_CANDIDATES: `${BaseURL}/all-candidates-list`,
  GET_CANDIDATES_FILTERS: `${BaseURL}/all-candidates-filters/`,
  GET_CANDIDATE_DETAILS: `${BaseURL}/candidate-detail`,

  GET_WORKFLOW_FINAL: `${BaseURL}/final-candidates`,

  GET_CANDIDATES_CITY_LIST: `${BaseURL}/all-candidates-city-list`,

  FROM_CRM: `${BaseURL}/from-crm`,
  UPDATE_PROJECT: `${BaseURL}/recruiter-project-update`,

  GET_CANDIDATE_TIMELINE: `${BaseURL}/candidate-timeline`,
  DOWNLOAD_CANDIDATE_TIMELINE: `${BaseURL}/candidate-timeline-download`,
  DOWNLOAD_FLEXIBEES_RESUME: `${BaseURL}/candidate-resume-download`,
  CANDIDATE_JOURNEY: `${BaseURL}/candidate-journey`,
  CANDIDATE_JOURNEY_FEEDBACK: `${BaseURL}/candidate-feedback-list`,
  CANDIDATE_DETAILS_UPDATE: `${BaseURL}/candidate-details-update/`,

  // project launch apis
  PROJECT_LAUNCH_LIST: `${BaseURL}/project/launch/list`,
  EDIT_PROJECT_NOTES: `${BaseURL}/project/launch/update`,
  PROJECT_DETAILS_DOWNLOAD: `${BaseURL}/project/launch/download`,
  MARKETPLACE_UPDATE: `${BaseURL}/candidate-detail-mp-update`,

  MP_LAUNCH_LIST: `${BaseURL}/job/launch/list`,
  MP_LAUNCH_LIST_UPDATE: `${BaseURL}/job/launch/update`,
  MP_LAUNCH_LIST_EXPORT: `${BaseURL}/job/launch/download`,

  CREATE_PROJECT_LAUNCH: `${BaseURL}/launch-project/`,
  UPDATE_PROJECT_LAUNCH: `${BaseURL}/update-project-launch`,

  MP_LAUNCH_NOTE_LIST: `${BaseURL}/job/launch/notes-list`,
  MP_LAUNCH_CREATE_NOTE: `${BaseURL}/job/launch/create-notes`,

  MP_OFFERS_LIST:`${BaseURL}/offer/list`,
  MP_OFFER_CREATE:`${BaseURL}/add-offer-launch`,
  MP_OFFER_UPDATE:`${BaseURL}/edit-offer-launch`,

  CREATE_PROJECT_RENEWALS:`${BaseURL}/project-renewal/create/`,
  PROJECT_RENEWALS_LIST:`${BaseURL}/project-renewals/list/`,
  PROJECT_LAUNCH_DETAILS:`${BaseURL}/project-launch/details`,
  RENEWALS_LAUNCH_UPDATE:`${BaseURL}/project-renewal/update`,
  UPDATE_RENEWALS:`${BaseURL}/project-renewal/update/`,

  MP_RENEWALS_CREATE: `${BaseURL}/job-renewal/create`,
  MP_RENEWALS_UPDATE: `${BaseURL}/job-renewal/update`,
  MP_RENEWALS_DETAILS: `${BaseURL}/job-renewal/details`,
  MP_RENEWALS_LIST: `${BaseURL}/job-renewals/list`,

  MP_FINANCE_LIST: `${BaseURL}/mplaunch-payments/payments-list`,
  MP_FINANCE_CREATE: `${BaseURL}/mplaunch-payments/create`,
  MP_FINANCE_UPDATE: `${BaseURL}/mplaunch-payments/update`, 

  MP_LAUNCH_DETAILS:`${BaseURL}/job_launch/details`, 
  UPLOAD_PAYMENTS:`${BaseURL}/mplaunch-payments/upload/`,
  ASSET_UPLOAD: `${CommonUrl}/asset-upload`,
  UPLOAD_LIST: `${BaseURL}/mplaunch-payments/uploads/list/`,
  UPLOAD_AGREEMENT:`${BaseURL}/job/launch/`,
    VIEW_AGREEMENT:`${BaseURL}/job/launch/view-agreement/`
};
